import AbstractGroupColumnTemplate from "./AbstractGroupColumnTemplate.js";
import GroupColumn from "../../../reports/columns/GroupColumn.js";

/**
 * Template for a group of columns provided by hand (in opposition to groups
 * generated based on parameters).
 *
 * This template is interpreted as a {@link GroupColumn}.
 *
 * @param {Renderable} [title] - Label for the group. This will be used as an
 *   umbrella-label for the sub-columns
 * @param {AbstractColumn[]} [columnTemplates] - List of column templates
 *   belonging to the group
 */
export default class ManualGroupColumnTemplate extends AbstractGroupColumnTemplate {
	constructor({ title, columnTemplates = [] } = {}) {
		super(...arguments);

		this._title = title;
		this._columnTemplates = columnTemplates;
	}

	setColumnTemplates(value) {
		this._columnTemplates = value;
	}

	getColumnTemplates() {
		return this._columnTemplates;
	}

	findColumnRecursively({ predicate }) {
		for (const column of this._columnTemplates) {
			if (predicate(column)) {
				return column;
			}

			const found = column.findColumnRecursively({
				predicate,
			});
			if (found) {
				return found;
			}
		}

		return undefined;
	}

	setReportTemplate(...args) {
		super.setReportTemplate(...args);

		for (const column of this._columnTemplates) {
			column.setReportTemplate?.(...args);
		}
	}

	accept(visitor) {
		return visitor.visitManualGroupColumnTemplate(this);
	}

	_instanceClass() {
		return GroupColumn;
	}

	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);

		spec.title = this._title;
		spec.columns = this._interpretColumns(interpreter);

		return spec;
	}

	_interpretColumns(interpreter) {
		return interpreter.interpretItemTemplates(this._columnTemplates);
	}
}
